import { Package, Layers, Star, CheckCircle2 } from 'lucide-react';
import { CatalogPlan } from '@/client/types/promotion-pricing/catalog';

interface PricingStatsProps {
  plans: CatalogPlan[];
}

const Stat = ({
  icon: Icon,
  label,
  value,
  accent,
}: {
  icon: typeof Package;
  label: string;
  value: number;
  accent: string;
}) => (
  <div className="flex items-center gap-3 rounded-xl border border-gray-100 bg-white px-4 py-3.5 shadow-sm">
    <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${accent}`}>
      <Icon className="h-4 w-4" />
    </div>
    <div>
      <p className="text-xl font-black leading-none text-gray-900">{value.toLocaleString()}</p>
      <p className="mt-1 text-xs font-medium text-gray-400">{label}</p>
    </div>
  </div>
);

/** Summary cards computed from the loaded catalog. */
export const PricingStats = ({ plans }: PricingStatsProps) => {
  const types = new Set(plans.map((p) => p.totid)).size;
  const active = plans.filter((p) => p.active).length;
  const featured = plans.filter((p) => p.popular || p.featured).length;

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <Stat icon={Package} label="Plans" value={plans.length} accent="bg-blue-50 text-blue-600" />
      <Stat icon={Layers} label="Types" value={types} accent="bg-violet-50 text-violet-600" />
      <Stat icon={CheckCircle2} label="Active" value={active} accent="bg-emerald-50 text-emerald-600" />
      <Stat icon={Star} label="Popular / featured" value={featured} accent="bg-amber-50 text-amber-600" />
    </div>
  );
};
